import { motion } from "framer-motion";
import { 
  Clock, 
  FolderKanban, 
  DollarSign, 
  BarChart3,
  Sparkles
} from "lucide-react";

const pillars = [
  {
    icon: Clock,
    title: "Controle de Tempo Inteligente",
    description: "Timer com um clique. Veja o valor de cada minuto trabalhado em tempo real.",
    bgColor: "bg-primary/10",
    borderColor: "border-primary/20",
    iconColor: "text-primary",
  },
  {
    icon: FolderKanban,
    title: "Projetos com Margem Automática",
    description: "Saiba instantaneamente se cada projeto está dando lucro ou prejuízo.",
    bgColor: "bg-purple-500/10",
    borderColor: "border-purple-500/20",
    iconColor: "text-purple-600",
  },
  {
    icon: DollarSign,
    title: "Controle Financeiro Real",
    description: "Pagamentos, parcelas e fluxo de caixa. Tudo organizado e previsível.",
    bgColor: "bg-success/10",
    borderColor: "border-success/20",
    iconColor: "text-success",
  },
  {
    icon: BarChart3,
    title: "Dashboard com Projeção e Alertas",
    description: "Saiba hoje quanto você vai faturar no fim do mês. Receba alertas inteligentes.",
    bgColor: "bg-warning/10",
    borderColor: "border-warning/20",
    iconColor: "text-warning",
  },
];

export function SolutionSection() {
  return (
    <section className="relative py-20 sm:py-28 bg-gradient-to-b from-background to-muted/30 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-radial from-primary/5 to-transparent rounded-full" />
      </div>

      <div className="container relative mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium mb-6">
            <Sparkles className="h-4 w-4" />
            A solução
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-wide text-foreground mb-4">
            O FREELADASH ORGANIZA{" "}
            <span className="text-primary">
              O QUE REALMENTE IMPORTA:
            </span>
          </h2>
          <p className="text-2xl sm:text-3xl font-bold text-primary">
            SUA RENDA.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((pillar, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -8, transition: { duration: 0.2 } }}
              className="group relative"
            >
              <div className={`h-full p-6 rounded-2xl bg-card border ${pillar.borderColor} hover:border-primary/30 hover:shadow-lg transition-all duration-300`}>
                {/* Icon */}
                <div className={`w-14 h-14 rounded-xl ${pillar.bgColor} flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300`}>
                  <pillar.icon className={`h-7 w-7 ${pillar.iconColor}`} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-foreground mb-3">
                  {pillar.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
